import { createSelector, orderBy, selectors, get } from '../dependencies';

export const restaurantsIsFetchingSelector = state => state.restaurants.isFetching;
export const restaurantsDataSelector = state => state.restaurants.data;
export const selectedSelector = state => state.restaurants.selected;
export const favouriteSelector = state => state.restaurants.favourite;

export const restaurantsSelector = createSelector(
    restaurantsDataSelector,
    favouriteSelector,
    (restaurants, favourite) => {
        return restaurants.map(restaurant => ({
            ...restaurant,
            isFavourite: Boolean(favourite[restaurant.id]),
        }));
    },
);

const nameCaseInsensitive = ({ name }) => name.toLowerCase();

export const restaurantsWithSelectedFlagSelector = createSelector(
    restaurantsSelector,
    selectedSelector,
    (restaurants, selected) => {
        const restaurantsWithExtraFlags = restaurants.map(restaurant => ({
            ...restaurant,
            isSelected: Boolean(selected[restaurant.id]),
            hasParser: Boolean(restaurant.parser),
        }));

        return orderBy(restaurantsWithExtraFlags, ['hasParser', nameCaseInsensitive], ['desc', 'asc']);
    },
);

const hasMenu = ({ menu }) => (Array.isArray(menu.data) ? menu.data.length > 0 : Boolean(menu.data));

export const selectedRestaurantsSelector = createSelector(
    restaurantsSelector,
    selectedSelector,
    selectors.triedToFetchSelector,
    selectors.menusKeyedByRestaurantIdSelector,
    (restaurants, selected, attemptsToFetch, menus) => {
        const selectedRestaurants = restaurants
            .filter(restaurant => Boolean(selected[restaurant.id]))
            .map(restaurant => {
                const restaurantId = restaurant.id;
                const menuData = get(menus, restaurantId, {});

                return {
                    ...restaurant,
                    menu: {
                        ...menuData,
                        isPristine: attemptsToFetch.indexOf(restaurantId) === -1,
                    },
                };
            });

        return orderBy(selectedRestaurants, ['isFavourite', hasMenu, nameCaseInsensitive], ['desc', 'desc', 'asc']);
    },
);
